import React from 'react';
import { Button, Text, Stack, Shelf, ButtonGroup, Card, Icon } from '@chaser/components';
import useOrganisation from '../../../../../hooks/useOrganisation';
import RequestAPITokenModal from '../RequestAPITokenModal.jsx/index.jsx';
import useModal from '../../../../../hooks/useModal';
import {
  IntegrationDisplayNames,
  OpenAPIIntegrationTypes,
  Integrations,
} from '../../../../../util/constants';
import getIntegrationIcon from '../getIntegrationIcon';

const OpenAPI = ({ ShortCode }) => {
  const showModal = useModal();
  const organisation = useOrganisation(ShortCode);
  const integrationType = OpenAPIIntegrationTypes[organisation.integration] || Integrations.OPENAPI;

  const integrationName = IntegrationDisplayNames[integrationType];
  const integrationIcon = getIntegrationIcon(integrationType);

  const isSage50 = integrationType === Integrations.SAGE50;

  const GetAPIKeysButton = () => {
    return (
      <Button
        appearance="primary"
        onClick={() => {
          showModal(<RequestAPITokenModal ShortCode={ShortCode} />);
        }}
      >
        Get API keys
      </Button>
    );
  };

  const Sage50UI = () => {
    const CHASER_CONNECTOR_URL =
      'https://7233458.fs1.hubspotusercontent-na1.net/hubfs/7233458/16%20-%20Chaser%20Connector/Chaser%20Setup.exe';

    const HELP_ARTICLE_URL = 'https://help.chaserhq.com/use-chaser-with-sage50';

    return (
      <Shelf justifyContent="space-between">
        <Shelf>
          <img src={integrationIcon} alt={integrationName} width={120} height={22} />
          <Stack gap="xsmall">
            <Text>{integrationName}</Text>
            <Text color="Mid Neutral 1">
              Learn how to connect Chaser to Sage 50&nbsp;<a href={HELP_ARTICLE_URL}>here</a>
            </Text>
          </Stack>
        </Shelf>
        <ButtonGroup>
          <Button
            as="a"
            href={CHASER_CONNECTOR_URL}
            icon={<Icon name="download" size="16" />}
            appearance="secondary"
          >
            Download Chaser Connector
          </Button>
          <GetAPIKeysButton />
        </ButtonGroup>
      </Shelf>
    );
  };

  const OpenAPIDefaultUI = () => {
    return (
      <Shelf justifyContent="space-between">
        <Shelf>
          <img src={integrationIcon} alt={integrationName} width={50} height={35} />
          <Stack gap="xsmall">
            <Text>{integrationName}</Text>
            <Text color="Mid Neutral 1">
              Accounting system used to synchronize your data with Chaser.
            </Text>
          </Stack>
        </Shelf>
        <ButtonGroup>
          <Button
            as="a"
            target="_blank"
            href="https://openapi.chaserhq.com/docs"
            icon={<Icon name="external" size="16" />}
            appearance="secondary"
          >
            Documentation
          </Button>
          <Button
            as="a"
            target="_blank"
            href="https://help.chaserhq.com/chaserapi"
            icon={<Icon name="external" size="16" />}
            appearance="secondary"
          >
            Help Center
          </Button>
          <GetAPIKeysButton />
        </ButtonGroup>
      </Shelf>
    );
  };

  return <Card p="large">{isSage50 ? <Sage50UI /> : <OpenAPIDefaultUI />}</Card>;
};

export default OpenAPI;
